import React from 'react';
import {
  LegalPageLayout,
  SectionTitle,
  Paragraph,
  List,
  ListItem,
  Strong,
} from '../components/LegalPageLayout';

const PrivacyPolicy: React.FC = () => (
  <LegalPageLayout title="Privacy Policy" updatedOn="October 2024">
    <Paragraph>
      “We”, “Us” or “Our” in this Agreement refers to Phinative Soft Private
      Limited, registered at Pent House, Plot 492, Venkataramana Colony,
      Telangana, India.
    </Paragraph>

    <SectionTitle>Introduction</SectionTitle>
    <Paragraph>
      We respect your privacy and are committed to protecting it through our
      compliance with this policy. This policy describes the types of
      information we may collect from you or that you may provide when you use
      our website or our apps and our practices for collecting, using,
      maintaining, protecting, and disclosing that information.
    </Paragraph>

    <SectionTitle>Information We Collect About You</SectionTitle>
    <Paragraph>We collect the following types of information:</Paragraph>
    <List>
      <ListItem>
        Information by which you may be personally identified, such as name and
        e-mail address, which you may disclose either voluntarily or
        involuntarily (<Strong>“personal information”</Strong>);
      </ListItem>
      <ListItem>
        Information that is about you but individually does not identify you,
        such as app usage behavior, diagnostics, and crash reports.
      </ListItem>
    </List>

    <SectionTitle>How We Use Your Information</SectionTitle>
    <Paragraph>We use information that we collect about you to:</Paragraph>
    <List>
      <ListItem>
        Enable cloud sync and present our website and its contents to you (cloud
        sync is optional);
      </ListItem>
      <ListItem>Fulfil any other purpose for which you provide it;</ListItem>
      <ListItem>
        Notify you about changes to our apps or any products or services we
        offer or provide through them;
      </ListItem>
      <ListItem>
        Allow you to participate in interactive features on our apps;
      </ListItem>
      <ListItem>
        Act in any other way we may describe when you provide the information;
      </ListItem>
      <ListItem>For any other purpose with your consent.</ListItem>
    </List>

    <SectionTitle>Data Retention</SectionTitle>
    <Paragraph>
      If you signed up for cloud sync, your app data and contact information will
      stay on our server until you request to delete your account or upon
      intimation if you are a dormant user for more than 365 days.
    </Paragraph>

    <SectionTitle>Disclosure of Your Information</SectionTitle>
    <Paragraph>
      We may disclose aggregated information about our users, and information
      that does not identify any individual, without restriction. We will not
      share or sell individual data by any means to anyone.
    </Paragraph>

    <SectionTitle>Accessing and Correcting Your Information</SectionTitle>
    <Paragraph>
      You can review and change your personal information by logging into your
      account and visiting your account profile page on our apps. You may also
      send us an email at <Strong>contact@21n.org</Strong> to request access to,
      correct, or delete any personal information that you have provided to us.
      We cannot delete your personal information except by also deleting your
      user account. We may not accommodate a request to change information if we
      believe the change would violate any law or legal requirement or cause the
      information to be incorrect.
    </Paragraph>

    <SectionTitle>Changes to This Privacy Policy</SectionTitle>
    <Paragraph>
      It is our policy to post any changes we make to our privacy policy on this
      page with a notice that the privacy policy has been updated on the website
      home page. If we make material changes to how we treat our users’ personal
      information, we will notify you by email to the primary email address
      specified in your account or through a notice on the website home page.
      The date the privacy policy was last revised is identified at the top of
      the page. You are responsible for ensuring we have an up-to-date active
      and deliverable email address for you, and for periodically visiting our
      website and this privacy policy to check for any changes.
    </Paragraph>

    <SectionTitle>Contact Information</SectionTitle>
    <Paragraph>
      To ask questions or comment about this privacy policy and our privacy
      practices, contact us at <Strong>contact@21n.org</Strong>.
    </Paragraph>
  </LegalPageLayout>
);

export default PrivacyPolicy;

